import type { StorageGateway, StoredReaderPdfReadingProgress } from "@/interface/DTO_Interfaces"
import { getReaderPdfStorageKey } from "@/ts/reader-pdf-storage-key"

export const READER_PDF_PROGRESS_STORAGE_KEY = "informatics/pdf-reading-progress"

const isStoredReaderPdfReadingProgress = (value: unknown): value is StoredReaderPdfReadingProgress => {
        if (!value || typeof value !== "object") return false

        const candidate = value as Partial<Record<keyof StoredReaderPdfReadingProgress, unknown>>

        return (
                typeof candidate.bookId === "string" &&
                typeof candidate.pdfId === "string" &&
                typeof candidate.pageNumber === "number" &&
                Number.isInteger(candidate.pageNumber) &&
                candidate.pageNumber > 0
        )
}

export const readReaderPdfReadingProgress = (
        gateway: StorageGateway,
        options: { bookId: string; pdfId: string }
): StoredReaderPdfReadingProgress | null => {
        const storedProgress = gateway.getItem<unknown>(getReaderPdfStorageKey(READER_PDF_PROGRESS_STORAGE_KEY, options))

        if (
                !isStoredReaderPdfReadingProgress(storedProgress) ||
                storedProgress.bookId !== options.bookId ||
                storedProgress.pdfId !== options.pdfId
        ) {
                return null
        }

        return storedProgress
}

export const hydrateReaderPdfReadingProgress = (
        gateway: StorageGateway,
        options: { bookId: string; pdfId: string }
): StoredReaderPdfReadingProgress => readReaderPdfReadingProgress(gateway, options) ?? { ...options, pageNumber: 1 }

export const saveReaderPdfReadingProgress = (
        gateway: StorageGateway,
        options: StoredReaderPdfReadingProgress
): StoredReaderPdfReadingProgress => {
        gateway.setItem(getReaderPdfStorageKey(READER_PDF_PROGRESS_STORAGE_KEY, options), options)

        return options
}
